import { createApi } from '@reduxjs/toolkit/query/react'
import Config from '../../../app.config';
import { transformResponse, baseQuery } from '../../helpers/rtk-query-tools';

export interface GetPlaylistArgs {
  stationId: number
  lastPlayedSongId?: number
  time: string
}

export interface GetSongArgs {
  persistentId: string
  stationId: number
}

export interface GetSoundbrandingTimetableDataArgs {
  stationId: number
}

export const getSongUrl = ({ persistentId, stationId, absolute }:
{ persistentId: string, stationId: number, absolute?: boolean }): string =>
  `${absolute === true ? Config.apiBaseUrl + '/' : ''}playlist/get_song/${persistentId}/${stationId}`;

export const getJingleUrl = ({ jingleId }:
{ jingleId: number }): string =>
  `${Config.apiBaseUrl}/playlist/get_jingle_mp3/${jingleId}`;

export const isNothingToPlay = (body: any): boolean =>
  body?.code === 'error' && body?.message === 'nothing_to_play';

export const apiCatalog = createApi({
  reducerPath: 'apiCatalog',
  baseQuery,
  // Evict unsubscribed playlist/song fetches quickly; args (time) vary each call
  keepUnusedDataFor: 30,
  endpoints: builder => ({
    getPlaylist: builder.query<any, GetPlaylistArgs>({
      query: args => `playlist/get_playlist/${args.stationId}/${args.lastPlayedSongId ?? 0}/${encodeURIComponent(args.time)}`,
      transformResponse
    }),
    getSong: builder.query<any, GetSongArgs>({
      query: args => ({
        url: getSongUrl(args),
        method: 'HEAD'
      })
    }),
    getStationTimetableData: builder.query<any, GetSoundbrandingTimetableDataArgs>({
      query: args => `customer_service/get_sound_branding_timetable/${args.stationId}}`,
      transformResponse
    }),
  })
});

export const {
  useLazyGetPlaylistQuery,
  useGetStationTimetableDataQuery,
  useLazyGetStationTimetableDataQuery,
  endpoints: {
    getPlaylist,
    getSong
  }
} = apiCatalog;
